import { useEffect, useState } from "react";

const API = "/api";

let cache;
let pending;

export const useGoogleReviews = () => {
  const [data, setData] = useState(cache || null);

  useEffect(() => {
    if (cache) return;
    if (!pending) {
      pending = fetch(`${API}/google-reviews`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
        .then((d) => {
          cache = d && d.rating ? d : null;
          return cache;
        });
    }
    let on = true;
    pending.then((d) => on && setData(d));
    return () => {
      on = false;
    };
  }, []);

  return data;
};
